module.exports = __webpack_public_path__ + "static/sec4-bg-28e777d006f7a3b29377975f635c1b29.jpg";